// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 777 ? "recorder" : chunkId) + "." + {"777":"10c0a44e45f15abb71ec","913":"48ebd20e9af9b5d825f3"}[chunkId] + ".js";
};